import { Box, Checkbox, Grid, Stack, Typography, useTheme } from "@mui/material";
import { QuestionOpenAIDto } from "generated/CoreApi_v1";
import React from "react";

/////////////////////////////////////////////////////////////////////////////////

interface IPros {
    questions: QuestionOpenAIDto[];
    onChange: (questions: QuestionOpenAIDto[]) => void;
}

/////////////////////////////////////////////////////////////////////////////////

export const GeneratorQuestionAIList: React.FC<IPros> = (props) => {
    const { questions, onChange } = props;

    const theme = useTheme();

    return (
        <Box height="350px" overflow="auto" marginTop={0.1}>
            <Grid container direction="column" mt={1} spacing={1}>
                {questions.map((item, index) => {
                    return (
                        <Grid key={index} alignItems="start">
                            <Grid container>
                                <Grid>
                                    <Checkbox
                                        checked={item.selected}
                                        onChange={(e) => {
                                            var newQuestions = [...questions];
                                            newQuestions[index].selected = e.target.checked;
                                            onChange(newQuestions);
                                        }}
                                    />
                                </Grid>
                                <Grid size="grow">
                                    <Stack direction="column">
                                        <Typography
                                            variant="h4"
                                            component="div"
                                            color={theme.palette.muted}
                                            sx={{ marginY: "8px" }}
                                        >
                                            {item.questionText}
                                        </Typography>
                                        {
                                            item.alternatives.map((alternative, index) => {
                                                return (
                                                    <Typography
                                                        key={index}
                                                        variant="caption"
                                                        component="div"
                                                        color={alternative.isInfo ? theme.palette.muted.light : theme.palette.muted}
                                                        fontWeight={alternative.isCorrect ? 900 : undefined}
                                                    >
                                                        {alternative.alternativeText}
                                                    </Typography>
                                                );
                                            })
                                        }
                                        {
                                            !!item.feedback && item.feedback?.length > 0 &&
                                            <Typography
                                                variant="caption"
                                                component="div"
                                                color={theme.palette.muted}
                                                sx={{ marginY: "8px" }}
                                            >
                                                Feedback: {item.feedback}
                                            </Typography>
                                        }
                                    </Stack>
                                </Grid>
                            </Grid>
                        </Grid>
                    );
                })}
            </Grid>
        </Box>
    );
};
